import React from 'react';
import Section from '../layout/Section';

const OverviewSection: React.FC = () => {
  return (
    <Section
      kicker="Overview"
      title="One workflow, two encryption layers."
      body="LockChain routes unlock logic through a single policy engine. LUKS volumes and ZFS datasets share the same configuration model, USB key workflow, and operator surfaces."
    >
      <div className="lc-grid lc-grid--3">
        <article className="lc-card">
          <div className="lc-card-tag">Objective</div>
          <h3 className="lc-card-title">Unified LUKS &amp; ZFS unlocks</h3>
          <p className="lc-card-body">
            A single unlock workflow for both LUKS volumes and ZFS datasets, where behaviour is
            driven by a common policy file rather than per-type shell fragments.
          </p>
        </article>

        <article className="lc-card">
          <div className="lc-card-tag">Surfaces</div>
          <h3 className="lc-card-title">Same rules, many faces</h3>
          <p className="lc-card-body">
            CLI, daemon, TUI and USB watcher all route through the same engine. Whether you&apos;re
            on a console, in logs or via the control deck, you&apos;re looking at the same workflow logic.
          </p>
        </article>

        <article className="lc-card">
          <div className="lc-card-tag">Posture</div>
          <h3 className="lc-card-title">Comfort without complacency</h3>
          <p className="lc-card-body">
            LockChain improves the day-to-day of encrypted storage without trivialising your
            security posture or hiding what happens at boot. Trade-offs are explicit, not hidden.
          </p>
        </article>
      </div>
    </Section>
  );
};

export default OverviewSection;
